import { createStyle } from '@gluestack-style/react';

export const ActionsheetFlatList = createStyle({
  w: '$full',
  h: 'auto',
});
